module.exports = __webpack_public_path__ + "static/media/holohunts.b0b0a7e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/holohunts.jpg
// module id = 56
// module chunks = 0